import Icon from "./Icon";

type BadgeKind =
  | "published"
  | "draft"
  | "archived"
  | "pending"
  | "approved"
  | "rejected"
  | "progress"
  | "plain";

const STATUS_ICON: Record<BadgeKind, string | null> = {
  published: "check",
  draft:     "pencil",
  archived:  "archive",
  pending:   "clock",
  approved:  "check",
  rejected:  "x",
  progress:  "rotate",
  plain:     null,
};

type BadgeProps = {
  kind: BadgeKind;
  children: React.ReactNode;
  icon?: string | null;
};

export default function Badge({ kind, children, icon }: BadgeProps) {
  const glyph = icon !== undefined ? icon : STATUS_ICON[kind];
  return (
    <span className={`badge badge-${kind}`}>
      {glyph && <Icon name={glyph} size={11} stroke={2} />}
      {children}
    </span>
  );
}
